
export const sizeNative = {
    "0": 0,
    "0165": 0.66,
    "025": 1,
    "050": 2,
    "100": 4,
    "150": 6,
    "200": 8,
    "275": 11,
    "300": 12,
    "325": 13,
    "350": 14,
    "400": 16,
    "450": 18,
    "500": 20,
    "550": 22,
    "600": 24,
    "700": 28,
    "750": 30,
    "800": 32,
    "900": 36,
    "1000": 40,
    "1200": 48,
    "1600": 64,
    "2000": 80,
    "2400": 96,
    "2800": 112,
    "3200": 128,
} as const;


export type Size = typeof sizeNative;

export type SizeScale = keyof Size;
